import React from 'react';
import { Box, Typography } from '@mui/material';
import Breadcrumbs from '../../components/layout/Breadcrumbs';
import SaleReturnRecord from '../../components/inventory/SaleReturnRecord';
import TransactionTable from '../../components/inventory/TransactionTable';
import DataExportButton from '../../components/common/DataExportButton';
import { TransactionProvider } from '../../contexts/TransactionContext';

const SaleReturnPage = () => {
  return (
    <TransactionProvider>
      <Box sx={{ padding: 3 }}>
        <Breadcrumbs items={[
          { label: 'Inventory Management', href: '/inventory' },
          { label: 'Sale & Return' }
        ]} />
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h5" component="h1" sx={{ fontWeight: 500, color: '#333' }}>
            Record Sale or Return
          </Typography>
        </Box>

        <SaleReturnRecord />

        <TransactionTable />
      </Box>
    </TransactionProvider>
  );
};

export default SaleReturnPage;
